import { Divider } from '@mui/material';
import { PaymentOption } from '@niarab2c/frontend-commons/src/types/hotels';
import { AddonCartItem as AddonCartItemSchema } from '@niarab2c/niarab2c-core/src/app/reducers/shoppingCart';
import groupAddonCartItems from '@niarab2c/niarab2c-core/src/util/addonCartItems/groupAddonCartItems';
import { useIsMobile } from '@niaratech/niara-react-components';
import React from 'react';
import CartTotal from '../HotelCart/CartTotal';
import AddonCartItem from './AddonCartItem';
import * as S from './styles';
export type AddonCartItem = AddonCartItemSchema & {
  onRemove?: () => void;
};
interface AddonCartProps {
  addonCartItems: AddonCartItem[];
  paymentOptions: PaymentOption[];
  isCartView?: boolean;
  onCheckout?: () => void;
  onGoToCart?: () => void;
  hideCartTotal?: boolean;
}
const AddonCart: React.FC<AddonCartProps> = ({
  addonCartItems,
  paymentOptions,
  isCartView,
  onCheckout,
  onGoToCart,
  hideCartTotal
}) => {
  const isMobile = useIsMobile();
  const cartTotalPrice = hideCartTotal ? undefined : addonCartItems.map(item => item?.addonResult?.priceComposition)?.reduce((acc, priceComposition) => {
    return {
      value: acc?.value + priceComposition?.total?.value,
      currency: priceComposition?.total?.currency,
      taxes: 0
    };
  }, {
    value: 0,
    currency: null,
    taxes: 0
  });
  const groupedAddonCartItems = groupAddonCartItems(addonCartItems ?? []);
  return <S.Container>
      {isCartView ? <S.CartItemsContainer>
          <S.CartTitle>Extras para a sua estadia</S.CartTitle>
          {groupedAddonCartItems?.map((item, idx) => <AddonCartItem key={idx} isCartView={isCartView} groupedCartItem={item} />)}
        </S.CartItemsContainer> : <S.CartItemsContainerWithoutIsCartView>
          {groupedAddonCartItems?.map((item, idx) => <React.Fragment key={idx}>
              <AddonCartItem isCartView={isCartView} groupedCartItem={item} />
              {!isMobile && idx < groupedAddonCartItems?.length - 1 && <S.DividerContainer>
                  <Divider />
                </S.DividerContainer>}
            </React.Fragment>)}
        </S.CartItemsContainerWithoutIsCartView>}

      {cartTotalPrice && <CartTotal cartTotal={cartTotalPrice} paymentOptions={paymentOptions ?? []} onCheckout={onCheckout} onGoToCart={onGoToCart} />}
    </S.Container>;
};
export default AddonCart;